// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPreOrderCreateDto } from './IPreOrderCreateDto';
import {
    IPreOrderCreateDtoFromJSON,
    IPreOrderCreateDtoFromJSONTyped,
    IPreOrderCreateDtoToJSON,
    IPreOrderCreateDtoToJSONTyped,
} from './IPreOrderCreateDto';

/**
 * 
 * @export
 * @interface ITradeCreateDto
 */
export interface ITradeCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ITradeCreateDto
     */
    investor_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ITradeCreateDto
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ITradeCreateDto
     */
    full_liquidation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ITradeCreateDto
     */
    side: ITradeCreateDtoSideEnum;
    /**
     * 
     * @type {Array<IPreOrderCreateDto>}
     * @memberof ITradeCreateDto
     */
    pre_orders?: Array<IPreOrderCreateDto>;
}

/**
* @export
* @enum {string}
*/
export enum ITradeCreateDtoSideEnum {
    BUY = 'BUY',
    SELL = 'SELL'
}


/**
 * Check if a given object implements the ITradeCreateDto interface.
 */
export function instanceOfITradeCreateDto(value: object): value is ITradeCreateDto {
    if (!('side' in value) || value['side'] === undefined) return false;
    return true;
}

export function ITradeCreateDtoFromJSON(json: any): ITradeCreateDto {
    return ITradeCreateDtoFromJSONTyped(json, false);
}

export function ITradeCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITradeCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investor_account_id': json['investor_account_id'] == null ? undefined : json['investor_account_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'full_liquidation': json['full_liquidation'] == null ? undefined : json['full_liquidation'],
        'side': json['side'],
        'pre_orders': json['pre_orders'] == null ? undefined : ((json['pre_orders'] as Array<any>).map(IPreOrderCreateDtoFromJSON)),
    };
}

export function ITradeCreateDtoToJSON(json: any): ITradeCreateDto {
    return ITradeCreateDtoToJSONTyped(json, false);
}

export function ITradeCreateDtoToJSONTyped(value?: ITradeCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investor_account_id': value['investor_account_id'],
        'amount': value['amount'],
        'full_liquidation': value['full_liquidation'],
        'side': value['side'],
        'pre_orders': value['pre_orders'] == null ? undefined : ((value['pre_orders'] as Array<any>).map(IPreOrderCreateDtoToJSON)),
    };
}

